module.exports = __webpack_public_path__ + "static/img/FR.0bba07e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/userTips/FR.png
// module id = BQrJ
// module chunks = 1